import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

export const RepresentativesAPI = (baseURL: string | undefined, clientId: string) => {
    const api = AxiosAPI({
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    });

    const saveLegalRepresentatives = (data: any) => {
        const serviceUrl = `/bookbuilding-api/LegalRepresentative/SaveLegalRepresentatives`;
        return api.post(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const updateLegalRepresentatives = (data: any) => {
        const serviceUrl = `/bookbuilding-api/LegalRepresentative/UpdateLegalRepresentatives`;
        return api.put(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const deleteLegalRepresentative = (representative: number) => {
        const serviceUrl = `/bookbuilding-api/LegalRepresentative/DeleteLegalRepresentative`;
        return api.delete(serviceUrl, {params: { id: representative }})
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };
	
    const getLegalRepresentatives = (contractId: number) => {
        const serviceUrl = `/bookbuilding-api/LegalRepresentative/GetLegalRepresentative`;
        return api.get(serviceUrl, { params: { contractId } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    return {
        saveLegalRepresentatives,
        updateLegalRepresentatives,
        deleteLegalRepresentative,
        getLegalRepresentatives,
    };
};